import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { inModalLayer, useModalDialog } from 'reusable/useModalDialog';

interface VideoModalProps {
    videoLink: string;
    onClose: () => void;
}

const VideoModal: React.FC<VideoModalProps> = ({ videoLink, onClose }) => {
  const { t } = useTranslation('common');
    const videoRef = useRef<HTMLVideoElement>(null);
    // ADM-16。Escape で閉じる・フォーカスを中に留める・閉じたら開いた操作へ戻す。
    const dialogRef = useModalDialog(true, onClose);

    useEffect(() => {
        const videoElement = videoRef.current;
        if (videoElement) {
            videoElement.addEventListener('loadedmetadata', () => {
                if (videoElement.videoWidth > videoElement.videoHeight) {
                    videoElement.style.width = '100%';
                    videoElement.style.height = 'auto';
                } else {
                    videoElement.style.width = 'auto';
                    videoElement.style.height = '100%';
                }
            });
        }
    }, []);

    const handleOutsideClick = (event: React.MouseEvent) => {
        if ((event.target as Element).classList.contains('modal-backdrop')) {
            onClose();
        }
    };

    const handleVideoEnd = () => {
        onClose();
    };

    return inModalLayer(
        <div className="fixed inset-0 flex justify-center items-center modal-backdrop bg-black bg-opacity-50" onClick={handleOutsideClick} data-backdrop>
            <div
                className="relative rounded-lg shadow-lg"
                onClick={e => e.stopPropagation()}
                data-backdrop
                role="dialog"
                aria-modal="true"
                aria-label={t('ui.play-video', { ns: 'common' })}
                ref={dialogRef}
                tabIndex={-1}
            >
                <div className="relative w-[1400px] h-[800px] flex items-center justify-center bg-black bg-opacity-90 rounded-lg">
                    <button type="button"
                        onClick={onClose} 
                        className="absolute top-0 right-0 text-lg font-bold text-white bg-transparent border-none cursor-pointer p-1 z-10"
                        aria-label={t('ui.close', { ns: 'common' })}
                        style={{ textShadow: '0 0 5px rgba(0, 0, 0, 0.5)' }}
                    >
                        &#x2715;
                    </button>
                    <div className="relative w-full h-full flex items-center justify-center">
                        <video 
                            ref={videoRef}
                            controls autoPlay 
                            className=""
                            onEnded={handleVideoEnd}
                        >
                            <source src={videoLink} type="video/mp4" />
                            {t('ui.video-unsupported', { ns: 'common' })}
                        </video>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VideoModal;